import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38bff897"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = { style: {"display":"flex","justify-content":"flex-end","padding-top":"8px"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("打印")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_12 = { style: {"margin":"0px 20px 20px 20px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "项目编号 : ", -1))
const _hoisted_14 = { style: {"margin":"0px 20px 20px 20px"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "库存数 : ", -1))
const _hoisted_16 = { class: "dialog-footer" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_19 = { style: {"margin":"0px 20px 20px 20px"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "项目编号 : ", -1))
const _hoisted_21 = { style: {"margin":"0px 20px 20px 20px"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "库存数 : ", -1))
const _hoisted_23 = { class: "background" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_26 = { class: "dialog-footer" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0px 20px 20px 20px"} }, "物料周期 : ", -1))
const _hoisted_30 = { class: "dialog-footer" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_33 = { class: "dialog-footer" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_36 = { style: {"display":"none"} }
const _hoisted_37 = {
  id: "barcode",
  class: "oneDelivery"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"width":"100%","text-align":"center"} }, "库存记录", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "middle_fifth" }, [
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_two" }, "序号"),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_three" }, "项目编号"),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_four" }, "品名"),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_three" }, "品号"),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_five" }, "规格"),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_six" }, "单位"),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_seven" }, "库位编号"),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_seven" }, "容器编号"),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_ninth" }, "备注")
], -1))
const _hoisted_40 = { class: "middle_fifth_two" }
const _hoisted_41 = { class: "middle_fifth_three" }
const _hoisted_42 = { class: "middle_fifth_four" }
const _hoisted_43 = { class: "middle_fifth_three" }
const _hoisted_44 = { class: "middle_fifth_five" }
const _hoisted_45 = { class: "middle_fifth_six" }
const _hoisted_46 = { class: "middle_fifth_seven" }
const _hoisted_47 = { class: "middle_fifth_seven" }
const _hoisted_48 = { class: "middle_fifth_ninth" }

import { reactive, ref, nextTick } from "vue";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import {
  getInventoryList,
  getInventoryDetailsList,
  getlocalList,
  printlocalList,
  updatamaterial,
  updateStockProject,
  AddStockProject,
  ErpOrderDetails
} from "@/service/main/statistical/index";
import { getStorageInfoShelvesList } from "@/service/main/warehouse";
import {
  getDicListData,
  getTimeData,
  updataTime
} from "@/service/main/warehouse/dicWare";
import { getSysDicListData } from "@/service/main/system/dic";
import { getCarrierInfoSelectList } from "@/service/main/warehouse";
import { inMethods } from "./inventoryList";
import Pagination from "@/components/Pagination/index.vue";
import dragMenu from "@/components/drag-menu/index.vue";
import print from "print-js";
import { exportExcel } from "@/utils/exportExcel";
import { conditionalExpression } from "@babel/types";
import EditModal from "./module/EditModal.vue";
// 顶部占位过多 展开/收起

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const hidden = ref(false);
const openSearch = () => {
  hidden.value = !hidden.value;
};

const rowClass = (
  row: any,
  column: number,
  rowIndex: number,
  columnIndex: number
) => {
  if (row.rowIndex === 0) {
    return "color: #606266;font-weight: bold;";
  }
};

const tableRowClassName = ({ row }: { row: any }) => {
  if (row.stockCircleName == "红") {
    return "warning-row";
  }
  return "";
};
// 当前选中的多选框，代表当前展示的列
const checkedColumns = ref([
  "项目编号",
  "容器编号",
  "库位编号",
  "所属库区",
  "到期时间",
  "品名",
  "品号",
  "规格型号",
  "单位",
  "检验方式",
  "数量",
  "物料周期",
  "更新时间",
  "操作"
]);
const checkList = ref([
  "项目编号",
  "容器编号",
  "库位编号",
  "所属库区",
  "到期时间",
  "品名",
  "品号",
  "规格型号",
  "单位",
  "检验方式",
  "数量",
  "物料周期",
  "创建时间",
  "更新时间",
  "操作"
]);

//点击更新物料周期按钮，单选按钮赋值
const stockCircleDtailsEnum: any = ref([]);
const timeEnum: any = ref([]);

const stockCircleEnum: any = ref([]);
const expirationOrNotEnum: any = ref([]);
// 物料周期下拉框数据获取
const getStockCircleDtailsData = () => {
  const obj = {
    CodeList: ["stock_circle"]
  };
  getDicListData(obj).then((res: any) => {
    stockCircleEnum.value = res.data[0];
    stockCircleDtailsEnum.value = res.data[0].filter(
      (item: any) => item.label != "全部"
    );
    stockCircleDtailsEnum.value.forEach((item: any) => {
      item.value = Number(item.value);
    });
  });
};
getStockCircleDtailsData();

const getYesNoEnum = function () {
  getSysDicListData({ Code: "yes_on_no" })
    .then((d: any) => {
      expirationOrNotEnum.value = d.data || [];
    })
    .catch((err: any) => {
      console.log(err);
    });
};
getYesNoEnum();

// 物料周期下拉框数据获取
const getTimeDtailsData = () => {
  getTimeData().then((res: any) => {
    console.log(res);
    timeEnum.value = res.data;
  });
};
getTimeDtailsData();
//查询
const formModel = reactive({
  CreateDate: [],
  SearchBeginTime: "",
  SearchEndTime: "",
  ProjectCode: "",
  SpecificationModel: "",
  Code: "",
  Name: "",
  PageNo: 1,
  PageSize: 20,
  StockCircle: "-10",
  YNExpiration: "-10",
  LocationCode: "",
  ContainerCode: "",
  AreaID: "-10"
});

// 重置
const reset = () => {
  formModel.CreateDate = [];
  formModel.SearchBeginTime = "";
  formModel.SearchEndTime = "";
  formModel.Code = "";
  formModel.Name = "";
  formModel.ProjectCode = "";
  formModel.PageNo = 1;
  formModel.PageSize = 20;
  formModel.StockCircle = "-10";
  formModel.LocationCode = "";
  formModel.ContainerCode = "";
  formModel.SpecificationModel = "";
  formModel.AreaID = "-10";
  getTableData();
};

//列表
const tableData = ref([]);
//列表的数据条数
const totalItems = ref<number>(0);
//获取库存列表
const getTableData = () => {
  if (formModel.CreateDate !== null && formModel.CreateDate.length !== 0) {
    formModel.SearchBeginTime = formModel.CreateDate[0];
    formModel.SearchEndTime = formModel.CreateDate[1];
  }
  getInventoryList(formModel)
    .then((res) => {
      const { data } = res;
      tableData.value = data.rows;
      totalItems.value = data.totalRows;
      formModel.SearchBeginTime = "";
      formModel.SearchEndTime = "";
    })
    .catch((err) => {
      ElMessage.error(JSON.stringify(err));
    });
};
getTableData();

// 库存详情抽屉默认关闭状态
const detailsDrawerModel = ref(false);
// 库存列表详情查询
const DetailsParams = reactive({
  Code: "",
  PageNo: 1,
  PageSize: 10
});

// 库存详情列表数据定义
const tableDataDetails = ref([]);
// 库存详情列表数据总数
const totalItemsDetails = ref<number>(0);
// 获取详情数据
const getDetailsListData = () => {
  getInventoryDetailsList(DetailsParams).then((res) => {
    const { data } = res;
    tableDataDetails.value = data.rows;
    totalItemsDetails.value = data.totalRows;
  });
};

//库存记录详情列表
const deltailList = ref<any[]>([]);
//通过时间查询当天库存记录表
const addForm = reactive({
  stockCircle: -10,
  stockDate: "",
  projectCode: "",
  quantity: 0,
  id: 0
});
// 更新项目号
const uprojectcode = (rows: any) => {
  uprojectcodeVisible.value = true;
  addForm.projectCode = rows.projectCode;
  addForm.quantity = rows.stockQuantity;
  addForm.id = rows.id;
  // console.log('row',rows)
};
const uprojectcodeVisible = ref(false);
const confirmuprojectcode = () => {
  console.log(addForm);
  updateStockProject(addForm).then((res) => {
    // console.log('res',res)
    uprojectcodeVisible.value = false;
    addForm.id = 0;
    getTableData();
    ElMessage.success("更新成功");
  });
};
//新增项目库存
const projects = reactive({ projectCode: "", quantity: 0 });
const projectList = ref<any[]>([]);
const addobjectnum = (rows: any) => {
  addobjectnumVisible.value = true;
  addForm.projectCode = rows.projectCode;
  addForm.quantity = rows.stockQuantity;
  addForm.id = rows.id;
  //console.log('row',rows)
};
const addobjectnumVisible = ref(false);
const confirmaddobjectnum = () => {
  let sum = projectList.value.reduce((sum, current, index) => {
    return sum + current.quantity;
  }, 0);
  if (sum > addForm.quantity) {
    return ElMessage.error("已超库存数量");
  }
  let para = {
    id: addForm.id,
    projectList: projectList.value
  };

  AddStockProject(para).then((res) => {
    projectList.value = [];
    addobjectnumVisible.value = false;
    addForm.id = 0;
    getTableData();
    ElMessage.success("更新成功");
  });
};
//新增项目库存
const addobject = (rows: any) => {
  //addobjectVisible.value = true
  projects.projectCode = "";
  projects.quantity = 0;
  projectList.value.push(projects);
  projectList.value = JSON.parse(JSON.stringify(projectList.value));
};

const deleteRow = (index: number) => {
  projectList.value.splice(index, 1);
};
// 更新物料周期
const updatadate = (rows: any) => {
  updatadateVisible.value = true;
  addForm.stockCircle = rows.stockCircle;
  addForm.id = rows.id;
  // console.log('row',rows)
};
const updatadateVisible = ref(false);
const confirm = () => {
  console.log(addForm);
  updatamaterial(addForm).then((res) => {
    // console.log('res',res)
    updatadateVisible.value = false;
    addForm.id = 0;
    getTableData();
    ElMessage.success("更新成功");
  });
};
// 更新时间周期
const updatadatetime = (rows: any) => {
  updatatimeVisible.value = true;
  // addForm.stockDate = rows.stockDate
  addForm.id = rows.id;
  // console.log('row',rows)
};
const updatatimeVisible = ref(false);
const confirms = () => {
  console.log(addForm);
  updataTime(addForm).then((res) => {
    // console.log('res',res)
    updatatimeVisible.value = false;
    addForm.id = 0;
    getTableData();
    ElMessage.success("更新成功");
  });
};

//打印/导出列表
const printData: any = ref([]);
var today = new Date().toLocaleDateString();
var tomorrow = new Date().getTime() + 3600 * 1000 * 24;
//查询
const printModel = reactive({
  CreateDate: [],
  SearchBeginTime: today.replace(/\//g, "-"),
  SearchEndTime: new Date(tomorrow).toLocaleDateString().replace(/\//g, "-"),
  PageNo: 1,
  PageSize: 10
});

// 重置
const printreset = () => {
  printModel.CreateDate = [];
  printModel.SearchBeginTime = today.replace(/\//g, "-");
  printModel.SearchEndTime = new Date(tomorrow)
    .toLocaleDateString()
    .replace(/\//g, "-");
  printModel.PageNo = 1;
  printModel.PageSize = 10;
  getPrintData();
};
//列表的数据条数
const printtotalItems = ref<number>(0);
const getPrintData = () => {
  if (printModel.CreateDate !== null && printModel.CreateDate.length !== 0) {
    printModel.SearchBeginTime = printModel.CreateDate[0];
    printModel.SearchEndTime = printModel.CreateDate[1];
  }
  getInventoryList(printModel)
    .then((res) => {
      const { data } = res;
      printData.value = data.rows;
      printtotalItems.value = data.totalRows;
      printModel.SearchBeginTime = today.replace(/\//g, "-");
      printModel.SearchEndTime = new Date(tomorrow)
        .toLocaleDateString()
        .replace(/\//g, "-");
    })
    .catch((err) => {
      ElMessage.error(JSON.stringify(err));
    });
};
//打印/导出记录弹框
const Printvisible = ref(false);
const receiptPrint = () => {
  Printvisible.value = true;
  getPrintData();
};
//打印确认按钮
const locallistPrint = () => {
  setTimeout(() => {
    print({
      printable: "barcode",
      type: "html",
      targetStyles: ["*"]
    });
    // printData.value = []
  }, 500);
};
//导出确认按钮
const locallistExport = () => {
  let entozh = {
    id: "序号",
    projectCode: "项目编号",
    name: "品名",
    code: "品号",
    specificationModel: "规格",
    unit: "单位",
    locationCode: "库位编号",
    containerCode: "容器编号"
  };
  exportExcel(printData.value, entozh, "xlsx", "库存记录");
};
//获取所属库区下拉框数据
const newAreaList: any = ref([]);
const getWareListData = () => {
  getStorageInfoShelvesList().then((res) => {
    res.data.unshift({
      id: "-10",
      areaName: "全部"
    });
    newAreaList.value = res.data;
  });
};
getWareListData();

const editId = ref("");
const editDetails = ref([]);
const mainEdit = ref({});
const editType = ref("");
const editVisible = ref(false);
const caigouPutIn = (row: any, type: any) => {
  editDetails.value = [];
  editId.value = row.id;
  editDetails.value = row.wareTransferOrderDetails;
  mainEdit.value = row;
  editType.value = type;
  editVisible.value = true;
};
const onDeatilActionCallback = function () {
  getTableData();
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: _unref(formModel),
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "品号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).Code,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).Code) = $event)),
                        placeholder: "请输入品号",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "项目编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).ProjectCode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).ProjectCode) = $event)),
                        placeholder: "请输入项目编号",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (hidden.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "创建时间:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _unref(formModel).CreateDate,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formModel).CreateDate) = $event)),
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "YYYY-MM-DD",
                              style: {"width":"100%"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "库位编号:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(formModel).LocationCode,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formModel).LocationCode) = $event)),
                              placeholder: "请输入库位编号",
                              clearable: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "规格型号:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(formModel).SpecificationModel,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formModel).SpecificationModel) = $event)),
                              placeholder: "请输入规格型号",
                              clearable: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "容器编号:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(formModel).ContainerCode,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formModel).ContainerCode) = $event)),
                              placeholder: "请输入容器编号",
                              clearable: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "品名:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(formModel).Name,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formModel).Name) = $event)),
                              placeholder: "请输入品名",
                              clearable: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "所属库区:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(formModel).AreaID,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formModel).AreaID) = $event)),
                              placeholder: "请选择所属库区",
                              size: "large",
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newAreaList.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.areaName,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "是否过期:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(formModel).YNExpiration,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formModel).YNExpiration) = $event)),
                              placeholder: "请选择...",
                              size: "large",
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expirationOrNotEnum.value, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTableData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: reset
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", {
                        onClick: openSearch,
                        class: "openSearch_Style"
                      }, [
                        _createTextVNode(_toDisplayString(hidden.value ? "收起" : "展开") + " ", 1),
                        _createElementVNode("i", {
                          class: _normalizeClass(hidden.value ? 'el-icon-arrow-up' : 'el-icon-arrow-down')
                        }, null, 2)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", null, [
          _createVNode(dragMenu, {
            modelValue: checkedColumns.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((checkedColumns).value = $event)),
            checkList: checkList.value,
            "onUpdate:checkList": _cache[10] || (_cache[10] = ($event: any) => ((checkList).value = $event))
          }, null, 8, ["modelValue", "checkList"])
        ])
      ]),
      _createVNode(_component_el_table, {
        data: tableData.value,
        border: "",
        style: {"width":"100%"},
        "header-cell-style": rowClass,
        "row-class-name": tableRowClassName
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          (checkedColumns.value.indexOf('项目编号') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "项目编号",
                prop: "projectCode",
                align: "center",
                width: ""
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('容器编号') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                label: "容器编号",
                prop: "containerCode",
                align: "center",
                width: ""
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('库位编号') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                label: "库位编号",
                prop: "locationCode",
                align: "center",
                width: ""
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('所属库区') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                label: "所属库区",
                prop: "reservoirArea",
                align: "center",
                width: ""
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('品名') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 4,
                label: "品名",
                prop: "name",
                align: "center",
                width: "250"
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('品号') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 5,
                label: "品号",
                prop: "code",
                align: "center",
                width: ""
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('规格型号') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 6,
                label: "规格型号",
                prop: "specificationModel",
                align: "center",
                width: "250"
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('单位') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 7,
                label: "单位",
                prop: "unit",
                align: "center",
                width: "60"
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('检验方式') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 8,
                label: "检验方式",
                align: "center",
                width: ""
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(inMethods)(scope.row.inspectionMethod)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('数量') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 9,
                label: "数量",
                prop: "stockQuantity",
                align: "center",
                width: "60"
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('物料周期') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 10,
                label: "物料周期",
                prop: "stockCircleName",
                align: "center",
                width: "80"
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('到期时间') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 11,
                label: "到期时间",
                prop: "expirationTime",
                align: "center",
                width: "160"
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('创建时间') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 12,
                label: "创建时间",
                prop: "createdTime",
                width: "160",
                align: "center"
              }))
            : _createCommentVNode("", true),
          (checkedColumns.value.indexOf('更新时间') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 13,
                label: "更新时间",
                prop: "updatedTime",
                width: "160",
                align: "center"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(Pagination, {
          total: totalItems.value,
          page: _unref(formModel).PageNo,
          "onUpdate:page": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formModel).PageNo) = $event)),
          limit: _unref(formModel).PageSize,
          "onUpdate:limit": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formModel).PageSize) = $event)),
          onPagination: getTableData
        }, null, 8, ["total", "page", "limit"])
      ])
    ]),
    _createVNode(EditModal, {
      visible: editVisible.value,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((editVisible).value = $event)),
      "order-id": editId.value,
      editDetails: editDetails.value,
      mainEdit: mainEdit.value,
      type: editType.value,
      onCallback: onDeatilActionCallback
    }, null, 8, ["visible", "order-id", "editDetails", "mainEdit", "type"]),
    _createVNode(_component_el_dialog, {
      modelValue: Printvisible.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((Printvisible).value = $event)),
      title: "打印/导出库存记录",
      width: "86%",
      onClose: _cache[18] || (_cache[18] = ($event: any) => (Printvisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(printModel),
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "打印时间区间:" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _unref(printModel).CreateDate,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(printModel).CreateDate) = $event)),
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "YYYY-MM-DD hh:mm:ss ",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          icon: "el-icon-search",
                          onClick: getPrintData
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          icon: "el-icon-refresh-right",
                          onClick: printreset
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "warning",
                          onClick: locallistPrint
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "success",
                          onClick: locallistExport
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_table, {
          data: printData.value,
          border: "",
          style: {"width":"100%"},
          "header-cell-style": rowClass
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              align: "center",
              width: "60",
              type: "index"
            }),
            (checkedColumns.value.indexOf('项目编号') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "项目编号",
                  prop: "projectCode",
                  align: "center",
                  width: "120"
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('库位编号') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  label: "库位编号",
                  prop: "locationCode",
                  align: "center",
                  width: "120"
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('容器编号') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 2,
                  label: "容器编号",
                  prop: "containerCode",
                  align: "center",
                  width: "120"
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('品名') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 3,
                  label: "品名",
                  prop: "name",
                  align: "center",
                  width: "140"
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('品号') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 4,
                  label: "品号",
                  prop: "code",
                  align: "center",
                  width: "120"
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('规格型号') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 5,
                  label: "规格型号",
                  prop: "specificationModel",
                  align: "center",
                  width: "250"
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('单位') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 6,
                  label: "单位",
                  prop: "unit",
                  align: "center"
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('检验方式') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 7,
                  label: "检验方式",
                  align: "center",
                  width: "90"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(inMethods)(scope.row.inspectionMethod)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('数量') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 8,
                  label: "数量",
                  prop: "stockQuantity",
                  align: "center"
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('物料周期') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 9,
                  label: "物料周期",
                  prop: "stockCircleName",
                  align: "center",
                  width: "90"
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('创建时间') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 10,
                  label: "创建时间",
                  prop: "createdTime",
                  width: "180",
                  align: "center"
                }))
              : _createCommentVNode("", true),
            (checkedColumns.value.indexOf('更新时间') >= 0)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 11,
                  label: "更新时间",
                  prop: "updatedTime",
                  width: "180",
                  align: "center"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(Pagination, {
          total: printtotalItems.value,
          page: _unref(printModel).PageNo,
          "onUpdate:page": _cache[15] || (_cache[15] = ($event: any) => ((_unref(printModel).PageNo) = $event)),
          limit: _unref(printModel).PageSize,
          "onUpdate:limit": _cache[16] || (_cache[16] = ($event: any) => ((_unref(printModel).PageSize) = $event)),
          onPagination: getPrintData,
          style: {"margin-top":"20px","text-align":"center"}
        }, null, 8, ["total", "page", "limit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: uprojectcodeVisible.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((uprojectcodeVisible).value = $event)),
      title: "项目编号更改",
      size: "20%",
      onClose: _cache[23] || (_cache[23] = ($event: any) => (uprojectcodeVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"font-size":"16px","margin-top":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_el_input, {
                    modelValue: _unref(addForm).projectCode,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(addForm).projectCode) = $event)),
                    placeholder: "请输入项目编号",
                    clearable: "",
                    style: {"padding-top":"10px"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_input, {
                    modelValue: _unref(addForm).quantity,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(addForm).quantity) = $event)),
                    modelModifiers: { number: true },
                    placeholder: "请输入库存数",
                    disabled: "",
                    clearable: "",
                    style: {"padding-top":"10px"}
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { offset: 1 }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (uprojectcodeVisible.value = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: confirmuprojectcode
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: addobjectnumVisible.value,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((addobjectnumVisible).value = $event)),
      title: "项目库存数新增",
      size: "20%",
      onClose: _cache[28] || (_cache[28] = ($event: any) => (addobjectnumVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"font-size":"16px","margin-top":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_el_input, {
                    modelValue: _unref(addForm).projectCode,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(addForm).projectCode) = $event)),
                    clearable: "",
                    style: {"padding-top":"10px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_el_input, {
                    modelValue: _unref(addForm).quantity,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(addForm).quantity) = $event)),
                    modelModifiers: { number: true },
                    clearable: "",
                    style: {"padding-top":"10px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_el_table, {
                data: projectList.value,
                style: {"width":"100%"},
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "projectCode",
                    label: "新项目号",
                    width: "125"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        modelValue: scope.row.projectCode,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.projectCode) = $event),
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "quantity",
                    label: "库存数",
                    width: "125"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        modelValue: scope.row.quantity,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.quantity) = $event),
                        modelModifiers: { number: true },
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    fixed: "right",
                    label: "操作",
                    width: "100"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        link: "",
                        type: "primary",
                        onClick: _withModifiers(($event: any) => (deleteRow(scope.$index)), ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "mt-4",
                style: {"width":"100%"},
                onClick: addobject
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_col, { offset: 1 }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_26, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (addobjectnumVisible.value = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: confirmaddobjectnum
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: updatadateVisible.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((updatadateVisible).value = $event)),
      title: "物料周期",
      size: "20%",
      onClose: _cache[32] || (_cache[32] = ($event: any) => (updatadateVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"font-size":"16px","margin-top":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _hoisted_29,
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(addForm).stockCircle,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(addForm).stockCircle) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stockCircleDtailsEnum.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        key: item.value,
                        label: item.value,
                        value: item.value,
                        style: {"margin-bottom":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { offset: 1 }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_30, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (updatadateVisible.value = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: confirm
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: updatatimeVisible.value,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((updatatimeVisible).value = $event)),
      title: "库存到期时间",
      size: "20%",
      onClose: _cache[36] || (_cache[36] = ($event: any) => (updatatimeVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"font-size":"16px","margin-top":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(addForm).stockDate,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(addForm).stockDate) = $event)),
                  placeholder: "请选择库存到期时间",
                  size: "large",
                  style: {"margin":"0px 20px 20px 20px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeEnum.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { offset: 1 }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_33, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[34] || (_cache[34] = ($event: any) => (updatatimeVisible.value = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: confirms
                  }, {
                    default: _withCtx(() => [
                      _hoisted_35
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        _hoisted_39,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(printData.value, (item, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "middle_fifth",
            style: {"border-top":"none"},
            key: index
          }, [
            _createElementVNode("td", _hoisted_40, _toDisplayString(index + 1), 1),
            _createElementVNode("td", _hoisted_41, _toDisplayString(item.projectCode), 1),
            _createElementVNode("td", _hoisted_42, _toDisplayString(item.name), 1),
            _createElementVNode("td", _hoisted_43, _toDisplayString(item.code), 1),
            _createElementVNode("td", _hoisted_44, _toDisplayString(item.specificationModel), 1),
            _createElementVNode("td", _hoisted_45, _toDisplayString(item.unit), 1),
            _createElementVNode("td", _hoisted_46, _toDisplayString(item.locationCode), 1),
            _createElementVNode("td", _hoisted_47, _toDisplayString(item.containerCode), 1),
            _createElementVNode("td", _hoisted_48, _toDisplayString(item.remark), 1)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})